import React, { useContext, useEffect, useState } from 'react';
import { Group, Stack, Text } from '@mantine/core';
import { useModals } from '@mantine/modals';
import { Trans } from '@lingui/react';
import { useParams } from 'react-router-dom';
import { IconRefresh } from '@tabler/icons';
import { CustomModalHeader } from '../../Dialogs';
import PanePaper from '../../PanePaper';
import BookitupAddIcon from '../../../Atoms/BookitupAddIcon';
import BookitupThemeIcon from '../../../Atoms/BookitupThemeIcon';
import SkeletonItems from '../../../Atoms/SkeletonItems';
import { ProfileContext } from '../../../Service/Context/ProfileContext';
import { EventContext } from '../../../Service/Context/EventContext';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import { LicenceS } from '../../../Service/LicenceS';
import { fetchTaskGroups } from '../../../Service/restapi/taskService';
import { TaskGroup } from './TaskGroup';

export default React.memo(() => {
  const { id: eventId } = useParams();
  const { profile, bookitupTeam } = useContext(ProfileContext);
  const { taskReloadTrigger } = useContext(EventContext);
  const [lastModified, setLastModified] = useState(new Date());
  const [taskGroups, setTaskGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const { openContextModal, closeAll } = useModals();
  const { executeWithLicenceCheck } = useContext(ViolationContext);

  useEffect(() => {
    setLoading(true);
    fetchTaskGroups('events')
      .then((resp) => {
        if (resp.ok) {
          resp.json().then((groups) => {
            setTaskGroups(groups);
          });
        } else {
          console.error('could not load taskLists for entityType events');
        }
      })
      .catch(() => {
        console.error('could not load taskLists for entityType events');
      })
      .finally(() => setLoading(false));
  }, [lastModified, taskReloadTrigger]);

  const openTaskCreateModal = () =>
    openContextModal('taskCreateModal', {
      title: (
        <CustomModalHeader>
          <Trans id="task.create" />
        </CustomModalHeader>
      ),
      innerProps: {
        profile,
        bookitupTeam,
        entityId: eventId,
        entityType: 'events',
        finish: () => {
          closeAll();
          setLastModified(new Date());
        },
      },
      centered: true,
    });

  return (
    <PanePaper
      withShadow
      withoutBorder
      title="Aufgaben"
      tooltip="help.event.tasks.pane"
      rightSection={
        <Group spacing="xs">
          {!loading && (
            <BookitupThemeIcon onClick={() => setLastModified(new Date())}>
              <IconRefresh />
            </BookitupThemeIcon>
          )}
          <BookitupAddIcon
            onClick={() => executeWithLicenceCheck(LicenceS.Restrictions.SAVE_TASK, openTaskCreateModal)}
          />
        </Group>
      }
    >
      {loading && <SkeletonItems height={50} />}
      {!loading && taskGroups.length === 0 && (
        <Text italic color="dimmed" size="xs" weight="lighter">
          Noch nichts hinzugefügt.
        </Text>
      )}
      {!loading && taskGroups.length > 0 && (
        <Stack spacing={5}>
          {taskGroups.map((group) => (
            <TaskGroup key={group.id} group={group} entityId={eventId} lastModified={lastModified} />
          ))}
        </Stack>
      )}
    </PanePaper>
  );
});
